import { createActionGroup, emptyProps } from '@ngrx/store';

export const customEntrySurveyAction = createActionGroup({
  source: 'Custom entry survey',
  events: {
    'load custom entry survey': emptyProps(),

    'save progress': emptyProps(),
    'save progress success': emptyProps(),

    'submit answer': emptyProps(),
    'submit answer success': emptyProps(),
  },
});
